// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"bb3c6d25","201":"76abb66f","231":"440ca93a","300":"95cad320","467":"0f9cf6ec","719":"b63c1c18","876":"49e8914f"}[chunkId] + ".chunk.js";
};